export const colors = {
  brand: {
    500: "#E6245A",
  },
  text: {
    900: "white",
    500: "#A6A6A6"
  }
};
